import store from './index'
import { authActions } from './auth-slice';
import { handleError, handleSessionExpired } from './error-handler';

export const fetchUserPermissions = () => {
    return async (dispatch) => {
        const fetchPermissions = async () => {
            const url = store.getState().auth.url; // Assuming the base URL is stored in the auth slice
            const token = localStorage.getItem('token'); // Retrieve token from localStorage

            const response = await fetch(`${url}api/user/permissions`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                if (response.status === 401) {
                    handleSessionExpired(dispatch, token);
                    throw new Error('Your session has expired. Please log in again.');
                } else {
                    throw new Error('Failed to fetch user permissions.');
                }
            }

            const data = await response.json();
            return data;
        };

        try {
            const permissions = await fetchPermissions();
            dispatch(authActions.setPermissions(permissions));
        } catch (error) {
            handleError(dispatch, error)
        } finally {
        }
    };
};